import { every, get } from 'lodash';
import {
  activeBadge,
  inactiveBadge,
  completedBadge,
  erroredBadge,
} from 'themes/colors';

export const STATUS_BADGE_LABEL = {
  active: 'Active',
  inactive: 'Inactive',
  completed: 'Completed',
  errored: 'Errored',
};

export const STATUS_BADGE_COLORS = {
  active: activeBadge,
  inactive: inactiveBadge,
  completed: completedBadge,
  errored: erroredBadge,
};

export const STATUS_CHANGE_OPTIONS = [
  { value: true, label: 'Active' },
  { value: false, label: 'Inactive' },
];

export const STATUS_CHANGEABLE = STATUS_CHANGE_OPTIONS.map(option => option.label.toLowerCase());

export const getBadgeStatus = (obj) => {
  if (get(obj, 'completed_date')) return 'completed';
  if (obj.email_service_provider_configs && every(obj.email_service_provider_configs, 'error_type')) return 'errored';
  if (get(obj, 'status')) return 'active';
  return 'inactive';
};
